import PessoaDiabetesIcon from '@/components/icons/IndicadoresAps/eSFeAP/PessoaDiabetes.vue'

export default {
  value: 'c4',
  label: 'Pessoa diabética',
  iconType: 'component',
  iconComponent: PessoaDiabetesIcon,
  buscaAtiva: {
    a: 'Pessoa sem avaliação de diabetes em consulta médica ou de enfermagem. Últimos 6 meses contados a partir do final do quadrimestre atual para trás.',
    b: 'Pessoa ainda não tem registro de aferição da pressão arterial, realizado nos últimos 6 meses.',
    c: 'Pessoa ainda não tem visitas domiciliares por ACS/Tacs, com intervalo mínimo de 30 dias, realizadas nos últimos 12 meses.',
    d: 'Pessoa ainda não tem registro de peso e altura, nos últimos 12 meses.',
    e: 'Pessoa ainda não tem registro de hemoglobina glicada, solicitada ou avaliada, nos últimos 12 meses.',
    f: 'Pessoa ainda não tem registro de avaliação dos pés, realizado nos últimos 12 meses.',
  },
}
